// extracted by mini-css-extract-plugin
export default {"button":"ProjectsMenu_button__nMUj4","text":"ProjectsMenu_text__SDPIi","dropdown":"ProjectsMenu_dropdown__0qGh7","dropdownList":"ProjectsMenu_dropdownList__RRwjg"};